module.exports = __webpack_public_path__ + "assets/img/passCloud.988764dd.png";